export default "__VITE_ASSET__DiEUtHQR__"